/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
  $(".Popover__Value").click(function(){
      var cams = $(".ProductMeta__Price").attr('cam_price');

setTimeout(function(){ 
var query = window.location.search.substring(1);
var vars = query.split("=");
var ID= vars[1];
//   console.log(ID);
        $(".metmain").hide();
    $(".metaff span").hide();
    $(".metaff ."+ ID).show();
  
  var cam = $(".ProductMeta__Price").attr('cam_price');
    var s = $(".ProductMeta__Price").attr('s_price');
 var sss= cam-s;
 var ssss = parseFloat(sss);
  ssss = ssss/100.00
  ssss= ssss.toFixed(2);
  if(cams!=cam){
    $(".ProductMeta__Price.saS").html("Sie sparen: "+ ssss+' €');
  }
  }, 500);
  });
